module.exports = __webpack_public_path__ + "img/you@2x.a863631c.png";